import { Modal } from "@circleco/compass/components/Modal";
import type { Editor } from "@tiptap/core";

import { t } from "@/i18n-js/instance";

import { PaywallSettingsContent } from "./PaywallSettingsContent";

const PAYWALL_SETTINGS_FORM_ID = "tiptap-paywall-settings-form";

interface PaywallSettingsModalComponentProps {
  editor: Editor;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  range: { from: number; to: number };
}

export const PaywallSettingsModalComponent = ({
  editor,
  range,
  open,
  onOpenChange,
}: PaywallSettingsModalComponentProps) => {
  const handleClose = () => onOpenChange(false);

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="md">
      <Modal.Content>
        <Modal.Header title={t("email_editor.paywall.edit_title")} />
        <Modal.Body>
          <PaywallSettingsContent
            formId={PAYWALL_SETTINGS_FORM_ID}
            editor={editor}
            range={range}
            onClose={handleClose}
          />
        </Modal.Body>
        <Modal.Footer
          primaryAction={{
            type: "submit",
            form: PAYWALL_SETTINGS_FORM_ID,
            label: t("email_editor.paywall.save"),
          }}
          secondaryAction={{
            label: t("cancel"),
            onClick: handleClose,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
